<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="tx in page_txs"
                         class="tx_list_item"
                         v-bind:key="tx['hash']"
                         v-bind:class="$mq">
        <TxSummary v-bind:tx="tx" />
      </b-list-group-item>
    </b-list-group>

    <MarkerPaginator v-on:prev="prev" v-on:next="next"
                     v-bind:markers="markers" v-bind:page="page" />
  </div>
</template>

<script>
import TxSummary from '../TxSummary'
import MarkerPaginator from '../MarkerPaginator'

// TODO: 'load all' button

export default {
  name: 'AccountDetailsTXs',

  components : {
    TxSummary,
    MarkerPaginator
  },

  props : {
    id : String,
    txs : Array,
    markers : Array,
  },

  data : function(){
    return {page : 0};
  },

  computed : {
    page_txs : function(){
      return this.txs[this.page];
    },
  },

  watch : {
    id : function(){
      this.page = 0;
      this.$emit('sync', this.page);
    }
  },

  methods : {
    prev : function(){
      this.page -= 1;
      this.$emit('sync', this.page);
    },

    next : function(){
      this.page += 1;
      this.$emit('sync', this.page);
    },
  }
}
</script>

<style scoped>
.tx_list_item.sm{
  padding: 5px;
}
</style>
